// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Homepage .hero {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  align-items: center;
  padding: 64px;
  text-align: center;
  margin-top: -48px; /* since page naturally has 20px top padding*/
  margin-bottom: 16px;
}
.Homepage .icon {
  width: 25px;
}
.Homepage .heroImage,
.Homepage .banner {
  background-color: #cccccc; /* Used if the image is unavailable */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}

.Homepage .hero h1,
.Homepage .hero p,
.Homepage .banner h2,
.Homepage .banner p {
  color: var(--white);
  filter: drop-shadow(4px 4px 2px black);
  margin: 0;
}

.Homepage .hero p,
.Homepage .banner p {
  font-size: 1.2em;
}

.Homepage .banner {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  padding: 32px;
  min-height: 300px;
}

.Homepage .accommodations {
  display: flex;
  gap: 32px;
  flex-direction: column;
}

.Homepage .AccommodationsCard {
  display: flex;
  gap: 48px;
  max-width: 700px;
  margin: 16px 0;
  min-height: 280px;
  flex-direction: row;
  margin: 0 auto 0 0;
  border-top: 2px solid lightgrey;
  padding-top: 32px;
  margin-bottom: 16px;
}

.Homepage .Alert a {
  color: #9D812C;
}

.Homepage .AccommodationsCard img {
  height: 280px;
  aspect-ratio: 1 / 1;
}

.Homepage .PersonalCareCard {
  background-color: var(--light);
  border: 2px solid var(--dark);
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px;
  cursor: pointer;
  text-align: center;
  height: 100%;
}

.Homepage .PersonalCareCard i {
  font-size: 1.4rem;
}

.Homepage .PersonalCareCard p {
  font-size: 1.1rem;
  margin-bottom: 0;
}

.Homepage .serviceCardGrid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.Homepage .SmallNewsCard {
  background-color: var(--light);
  border: 2px solid var(--dark);
  border-radius: 6px;
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  padding: 16px;
  height: 100%;
}

.Homepage .SmallNewsCard h3 {
  margin: 0;
  margin-bottom: 8px;
}

.Homepage .newsGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 8px;
  margin-bottom: 32px;
}

.Homepage .history {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 16px;
  border-top: 2px solid lightgrey;
  border-bottom: 2px solid lightgrey;
  padding: 32px 0;
}

.Homepage .history img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: var(--box-shadow);
}

.Homepage .history > div {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 16px;
  max-width: 400px;
  margin-right: 0;
  margin-left: auto;
  text-align: end;
}

@media (max-width: 1100px) {
  .Homepage .serviceCardGrid {
    grid-template-columns: 1fr 1fr;
  }

  .Homepage .serviceCardGrid :last-child {
    grid-column: span 2;
  }
  .Homepage .newsGrid {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
  }
}

@media (max-width: 800px) {
  .Homepage .history {
    grid-template-columns: 1fr;
  }
  .Homepage .history > div {
    text-align: center;
    max-width: 400px;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px auto;
  }
  .Homepage .history img {
    order: 2;
    max-width: 500px;
    margin: 0 auto;
  }
}

@media (max-width: 500px) {
  .Homepage .AccommodationsCard {
    flex-direction: column !important;
  }

  .Homepage .AccommodationsCard > div {
    width: 100% !important;
  }

  .Homepage .serviceCardGrid {
    grid-template-columns: 1fr;
  }
  .Homepage .serviceCardGrid :last-child {
    grid-column: span 1;
  }
  .Homepage .newsGrid {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/Homepage.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB,EAAE,6CAA6C;EAChE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;;EAEE,yBAAyB,EAAE,qCAAqC;EAChE,2BAA2B,EAAE,qBAAqB;EAClD,4BAA4B,EAAE,4BAA4B;EAC1D,sBAAsB,EAAE,8DAA8D;AACxF;;AAEA;;;;EAIE,mBAAmB;EACnB,sCAAsC;EACtC,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,+BAA+B;EAC/B,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,QAAQ;IACR,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;AACF","sourcesContent":[".Homepage .hero {\n  height: 60vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 16px;\n  align-items: center;\n  padding: 64px;\n  text-align: center;\n  margin-top: -48px; /* since page naturally has 20px top padding*/\n  margin-bottom: 16px;\n}\n.Homepage .icon {\n  width: 25px;\n}\n.Homepage .heroImage,\n.Homepage .banner {\n  background-color: #cccccc; /* Used if the image is unavailable */\n  background-position: center; /* Center the image */\n  background-repeat: no-repeat; /* Do not repeat the image */\n  background-size: cover; /* Resize the background image to cover the entire container */\n}\n\n.Homepage .hero h1,\n.Homepage .hero p,\n.Homepage .banner h2,\n.Homepage .banner p {\n  color: var(--white);\n  filter: drop-shadow(4px 4px 2px black);\n  margin: 0;\n}\n\n.Homepage .hero p,\n.Homepage .banner p {\n  font-size: 1.2em;\n}\n\n.Homepage .banner {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 16px;\n  padding: 32px;\n  min-height: 300px;\n}\n\n.Homepage .accommodations {\n  display: flex;\n  gap: 32px;\n  flex-direction: column;\n}\n\n.Homepage .AccommodationsCard {\n  display: flex;\n  gap: 48px;\n  max-width: 700px;\n  margin: 16px 0;\n  min-height: 280px;\n  flex-direction: row;\n  margin: 0 auto 0 0;\n  border-top: 2px solid lightgrey;\n  padding-top: 32px;\n  margin-bottom: 16px;\n}\n\n.Homepage .Alert a {\n  color: #9D812C;\n}\n\n.Homepage .AccommodationsCard img {\n  height: 280px;\n  aspect-ratio: 1 / 1;\n}\n\n.Homepage .PersonalCareCard {\n  background-color: var(--light);\n  border: 2px solid var(--dark);\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  cursor: pointer;\n  text-align: center;\n  height: 100%;\n}\n\n.Homepage .PersonalCareCard i {\n  font-size: 1.4rem;\n}\n\n.Homepage .PersonalCareCard p {\n  font-size: 1.1rem;\n  margin-bottom: 0;\n}\n\n.Homepage .serviceCardGrid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n}\n\n.Homepage .SmallNewsCard {\n  background-color: var(--light);\n  border: 2px solid var(--dark);\n  border-radius: 6px;\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  padding: 16px;\n  height: 100%;\n}\n\n.Homepage .SmallNewsCard h3 {\n  margin: 0;\n  margin-bottom: 8px;\n}\n\n.Homepage .newsGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-gap: 8px;\n  margin-bottom: 32px;\n}\n\n.Homepage .history {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 16px;\n  border-top: 2px solid lightgrey;\n  border-bottom: 2px solid lightgrey;\n  padding: 32px 0;\n}\n\n.Homepage .history img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 8px;\n  box-shadow: var(--box-shadow);\n}\n\n.Homepage .history > div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 16px;\n  max-width: 400px;\n  margin-right: 0;\n  margin-left: auto;\n  text-align: end;\n}\n\n@media (max-width: 1100px) {\n  .Homepage .serviceCardGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .Homepage .serviceCardGrid :last-child {\n    grid-column: span 2;\n  }\n  .Homepage .newsGrid {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr 1fr;\n  }\n}\n\n@media (max-width: 800px) {\n  .Homepage .history {\n    grid-template-columns: 1fr;\n  }\n  .Homepage .history > div {\n    text-align: center;\n    max-width: 400px;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 16px auto;\n  }\n  .Homepage .history img {\n    order: 2;\n    max-width: 500px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 500px) {\n  .Homepage .AccommodationsCard {\n    flex-direction: column !important;\n  }\n\n  .Homepage .AccommodationsCard > div {\n    width: 100% !important;\n  }\n\n  .Homepage .serviceCardGrid {\n    grid-template-columns: 1fr;\n  }\n  .Homepage .serviceCardGrid :last-child {\n    grid-column: span 1;\n  }\n  .Homepage .newsGrid {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(4, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
